import { Box, Card, CircularProgress, Stack, Typography } from '@mui/material';
import { QuestionsButtons } from '@/components/pickem-edit/QuestionsSection/QuestionsButtons.tsx';
import { QuestionsOrderingTable } from '@/components/pickem-admin/QuestionsOrderingTable.tsx';
import { QuestionsTable } from '@/components/pickem-admin/QuestionsTable.tsx';
import { useGetPickem } from '@/api/pickems/getPickem.ts';
import { usePickemStore } from '@/store/usePickem.store.ts';
import { AnyFieldApi } from '@tanstack/react-form';
import { useAppSearchParams } from '@/hooks/useAppSearchParams.ts';

interface QuestionsSectionProps {
  form: any;
  lang: {
    code: string;
    label: string;
  };
  bonusOptionClickHandler: (questionId: number, optionLabel: string) => void;
  matchStats: (index: number, option: string) => void;
}

export const QuestionsSection = ({
  form,
  lang,
  bonusOptionClickHandler,
  matchStats,
}: QuestionsSectionProps) => {
  const { pickemId } = useAppSearchParams();
  const { isOrderingMode } = usePickemStore();
  const { isLoading } = useGetPickem(pickemId);

  return (
    <>
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='space-between'
        mb={0}
        mt={3}
      >
        <Typography variant='h4' gutterBottom>
          Questions {lang.label}
        </Typography>
        <QuestionsButtons form={form} />
      </Stack>

      <Card sx={{ padding: 1, marginTop: 1 }}>
        {isLoading ? (
          <Box
            sx={{ display: 'flex', justifyContent: 'center' }}
            style={{ padding: 20 }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <form.Field
            name='questions'
            children={({ state }: AnyFieldApi) =>
              isOrderingMode ? (
                <QuestionsOrderingTable questions={state.value} form={form} />
              ) : (
                <QuestionsTable
                  lang={lang.code}
                  questions={state.value}
                  bonusOptionClickHandler={bonusOptionClickHandler}
                  showActions={true}
                  matchStats={matchStats}
                  form={form}
                />
              )
            }
          />
        )}
      </Card>
    </>
  );
};
